export type PrescriptionForm =
  | 'TABLET'
  | 'CAPSULE'
  | 'SYRUP'
  | 'INJECTION'
  | 'TOPICAL'
  | 'DROPS'
  | 'OTHER';

export const PRESCRIPTION_FORMS: PrescriptionForm[] = [
  'TABLET',
  'CAPSULE',
  'SYRUP',
  'INJECTION',
  'TOPICAL',
  'DROPS',
  'OTHER',
];

export type PrescriptionItem = {
  id: string;
  drug_name: string;
  strength: string | null;
  form: PrescriptionForm;
  dosage: string | null;
  frequency: string | null;
  duration_days: number | null;
  instructions: string | null;
  display_order: number;
};

export type MedicalRecord = {
  id: string;
  booking_id: string;
  pet_id: string;
  vendor_profile_id: string;
  module_type: string;
  status: 'DRAFT' | 'FINALIZED';
  chief_complaint: string | null;
  diagnosis: string;
  clinical_notes: string | null;
  weight_kg: string | null;
  follow_up_on: string | null;
  finalized_at: string | null;
  created_at: string;
  updated_at: string;
  prescription: { id: string; advice: string | null; items: PrescriptionItem[] } | null;
  /** Uploaded prescription photos (scanned/photographed Rx). Empty for structured-only records. */
  prescription_documents: PrescriptionDoc[];
};

/** A pet the vet can attach to a visit that was booked without one. */
export type RecordPetOption = {
  id: string;
  name: string;
  species: string;
};

/** A stored prescription image with auth-gated thumb + full paths. */
export type PrescriptionDoc = {
  id: string;
  thumb_path: string;
  full_path: string;
};

/** One drug line in the editor payload (server assigns id + display_order). */
export type PrescriptionItemInput = {
  drug_name: string;
  strength?: string;
  form: PrescriptionForm;
  dosage?: string;
  frequency?: string;
  duration_days?: number;
  instructions?: string;
};

export type UpsertRecordInput = {
  pet_id?: string;
  chief_complaint?: string;
  diagnosis?: string;
  clinical_notes?: string;
  weight_kg?: number;
  follow_up_on?: string;
  prescription?: { advice?: string; items: PrescriptionItemInput[] };
};
